import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidator } from '../../../../../../../common/forms/custom.validators';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite
} from '../../../../../../../openapi';

@Injectable()
export class InjuredPersonForm extends AppForm {
  constructor() {
    super({
      firstName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      lastName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      phone: new FormControl('', {
        validators: [Validators.required, CustomValidator.phone(), Validators.maxLength(255)],
        nonNullable: true
      }),
      email: new FormControl('', {
        validators: [
          Validators.required,
          CustomValidator.email(),
          Validators.maxLength(255)
        ],
        nonNullable: true
      }),
      zipCode: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      postOffice: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      city: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      street: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      buildingNumber: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      apartmentNumber: new FormControl('', Validators.maxLength(255))
    });
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead) {
    super.patchFormValues({
      firstName: value?.correspondenceFirstName,
      lastName: value?.correspondenceLastName,
      phone: value?.correspondencePhone,
      email: value?.correspondenceEmail,
      zipCode: value?.correspondencePostalCode,
      postOffice: value?.correspondencePostOffice,
      city: value?.correspondenceCity,
      street: value?.correspondenceStreet,
      buildingNumber: value?.correspondenceHouseNumber,
      apartmentNumber: value?.correspondenceApartmentNumber
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      correspondenceFirstName: this.value.firstName,
      correspondenceLastName: this.value.lastName,
      correspondencePhone: this.value.phone,
      correspondenceEmail: this.value.email,
      correspondencePostalCode: this.value.zipCode,
      correspondencePostOffice: this.value.postOffice,
      correspondenceCity: this.value.city,
      correspondenceStreet: this.value.street,
      correspondenceHouseNumber: this.value.buildingNumber,
      correspondenceApartmentNumber: this.value.apartmentNumber
    };
  }
}
